const trioSlider = () => {
	const servTrio = $('.trio-slide');
	const servSettings = {
		mobileFirst: true,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		draggable: true,
		arrows: false,
		centerMode: true,
		responsive: [
			{
				breakpoint: 1010,
				settings: 'unslick',
			},
			{
				breakpoint: 715,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					centerMode: false,
				},
			},
		],
	};

	servTrio.slick(servSettings);
	$(window).on('resize', function () {
		if ($(window).width() > 1010) {
			return;
		}
		if (!servTrio.hasClass('slick-initialized')) {
			return servTrio.slick(servSettings);
		}
	});

	const threeSlides = $('.threeSlides__cont--slider');
	if (threeSlides.length > 0) {
		const threeSettings = {
			mobileFirst: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			autoplay: false,
			draggable: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 1010,
					settings: 'unslick',
				},
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 1.8,
						slidesToScroll: 1,
						centerMode: true,
					},
				},
				{
					breakpoint: 650,
					settings: {
						slidesToShow: 1.6,
						slidesToScroll: 1,
						centerMode: true,
					},
				},
			],
		};

		threeSlides.slick(threeSettings);
		$(window).on('resize', function () {
			if ($(window).width() > 1010) {
				return;
			}
			if (!threeSlides.hasClass('slick-initialized')) {
				return threeSlides.slick(threeSettings);
			}
		});
	}
};

export default trioSlider;
